// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mHTEd","questions":"styles_questions__1VkNa","footer":"styles_footer__laZBD"};